// ==============================|| OVERRIDES - TOOLTIP ||============================== //

import { Theme } from '@mui/material/styles';

export default function Tooltip(theme: Theme) {
  return {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#fff',
          color: theme.palette.text.primary,
          border: '1px solid',
          borderColor: theme.palette.grey[400],
          boxShadow: '0 4px 14px rgba(0,0,0,0.10)',
          fontSize: 13
        },
        arrow: {
          color: '#fff',
          '&::before': {
            border: '1px solid',
            borderColor: theme.palette.grey[400]
          }
        }
      }
    }
  };
}
